import { enumType } from '@shared/core/types/common';

enum LOYALTY_POINTS_MODE {
    PURE_POINTS = OLO.Enums.LOYALTY_POINTS_MODE.PURE_POINTS,
    POINTS_AS_REWARD_DOLLARS = OLO.Enums.LOYALTY_POINTS_MODE.POINTS_AS_REWARD_DOLLARS,
}

export const loyaltyPointsModeEnum = enumType('LOYALTY_POINTS_MODE', LOYALTY_POINTS_MODE);
